module.exports = __webpack_public_path__ + "static/media/edit-light.8c65aeee.svg";